import { withStyles } from "@material-ui/core";
import { createStyles, Theme } from "@material-ui/core/styles";
import * as React from "react";

const styles = (theme: Theme) => createStyles({});

interface IProps {
  id: string;
  value: number;
  currencyCode: string;
  callbackUrl: string;
  clientId: string;
  bookingId: string;
}

const iOSTransaction: React.SFC<IProps> = (props: IProps) => {
  const squareTransaction = {
    amount_money: {
      amount: `${props.value}`,
      currency_code: props.currencyCode
    },
    callback_url: props.callbackUrl,
    client_id: props.clientId,
    version: "1.3",
    notes: `#${props.bookingId}_${props.id}`,
    options: {
      supported_tender_types: ["CREDIT_CARD"],
      disable_cnp: true,
      skip_receipt: true,
      auto_return: true
    }
  };

  const url = `square-commerce-v1://payment/create?data=${encodeURIComponent(JSON.stringify(squareTransaction))}`;

  // Launch Square App
  window.location.assign(url);

  return <div>Launching payment for booking #{props.bookingId}</div>;
};

export default withStyles(styles)(iOSTransaction);



// WEBPACK FOOTER //
// ./src/components/IOSTransaction.tsx